import { NgModule } from '@angular/core';
import { FlashpayRoutingModule } from 'features/flashpay/flashpay-routing.module';

@NgModule({
  imports: [
    FlashpayRoutingModule
  ]
})
export class FlashpayModule { }
